import { render, staticRenderFns } from "./one-column-list.vue?vue&type=template&id=6d537502&"
import script from "./one-column-list.vue?vue&type=script&lang=js&"
export * from "./one-column-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports